export function invoiceProductDescription(product) {
  if (!product) {
    return "";
  }

  const title = product.display_name || product.name || "";
  const tags =
    product.tags_subtitle ||
    (product.stock_tags || [])
      .map((tag) => tag.label || tag.name)
      .filter(Boolean)
      .join(", ");
  const temperature = product.temperature
    ? product.temperature.label || product.temperature.name
    : "";
  const country = product.origin_country
    ? product.origin_country.name || product.origin_country.label
    : "";
  const parts = [tags, temperature, country].filter(Boolean);

  return parts.length ? `${title} (${parts.join(", ")})` : title;
}
